import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ downtimeReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `downtimereason/getsearched`,
      params: downtimeReasonParams,
    });
    const allDowntime = data;
    yield put(Actions.setAll({ allDowntime }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchDowntimeCategories() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `downtimecategory/downtimecategories/`,
    });

    const downtimeCategories = data;
    yield put(Actions.setAllDowntimeCategories({ downtimeCategories }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchDowntimeReasonByCategoryId({ downtimeCategoryId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `downtimereason/downtimecategoryreasons/` + downtimeCategoryId,
    });

    const downtimeCategoryReasons = data;
    yield put(Actions.setAllDowntimeCategoriesReason({ downtimeCategoryReasons }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateDowntimeReason({ downtimeReasonData, actionName, downtimeReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `downtimereason`,
      data: downtimeReasonData,
    });
    yield put(Actions.fetchAll({ downtimeReasonParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.DOWNTIME_REASON_CREATED
        : CONSTANT_VARIABLES.DOWNTIME_REASON_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteDowntimeReason({ id, downtimeReasonParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `downtimereason/${id}`,
    });
    yield put(Actions.fetchAll({ downtimeReasonParams }));
    notification('success', CONSTANT_VARIABLES.DOWNTIME_REASON_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllDowntimeReason() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `downtimereason/GetAllDowntimeReasonData`,
    });
    const allDowntimeReasonData = data;
    yield put(Actions.setAllDowntimeReason({ allDowntimeReasonData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_DOWNTIME_CATEGORIES, fetchDowntimeCategories),
    takeLatest(ActionTypes.FETCH_DOWNTIME_REASON_BY_CATEGORYID, fetchDowntimeReasonByCategoryId),
    takeLatest(ActionTypes.ADD_OR_UPDATE_DOWNTIME_REASON, addorUpdateDowntimeReason),
    takeLatest(ActionTypes.DELETE_DOWNTIME_REASON, deleteDowntimeReason),
    takeLatest(ActionTypes.FETCH_ALL_DOWNTIME_REASON, fetchAllDowntimeReason),
  ]);
}
